$(document).ready(function() {
   // Select the elements to wrap
  var elementsToWrap = $('#shopify-section-sections--16174779203663__announcement-bar, #shopify-section-sections--16174779203663__header');
  
  // Wrap them inside a single custom div
  elementsToWrap.wrapAll('<div class="custom-wrapper-start"></div>');

  var stickyThreshold = 100; // Adjust this value to your desired scroll point
  
  $(window).scroll(function() {
    var scrollTop = $(window).scrollTop();
    var wrapper = $('.custom-wrapper-start');

    if (scrollTop > stickyThreshold) {
      if (!wrapper.hasClass('sticky')) {
          wrapper.addClass('sticky').css('opacity', 1); // Ensure it's visible
      }
    } else {
      if (wrapper.hasClass('sticky')) {
          wrapper.removeClass('sticky').css('opacity', 1); // Ensure it's visible
      }
    }
  });

    $('#SortBy').select2({
        minimumResultsForSearch: Infinity, // Disable the search box for this select
        width: '100%' // Full width of the container
    });
});
if($('.home-slider').length){
    $('.home-slider').owlCarousel({
        responsiveClass:true,
        loop:true,
        items:1,
        dots:false,
        nav:true,
        navText:[
            "<div class='fa'>&#xf104;</div>","<div class='fa'>&#xf105;</div>"
        ],
        lazyLoad:true,
        autoplay:true,
        autoplayTimeout:5000,
        autoplayHoverPause:false,
        rewind:true,
      responsive:{

            0:{
                
                nav:false,
            },




            992:{
                nav:true
            },
        }
    });
}



if($('.testi-slider').length){

    $('.testi-slider').owlCarousel({
        center:true,
        responsiveClass:true,
        items:3,
        loop:true,
        dots:false,
        nav:true,
        navText:[
            "<div class='ion-ios-arrow-thin-left'>&nbsp;</div>","<div class='ion-ios-arrow-thin-right'>&nbsp;</div>"
        ],
  lazyLoad:true,
        autoplay:true,
        autoplayTimeout:5000,
        autoplayHoverPause:false,
        rewind:true,
        responsive:{

            0:{
                items:1,
                nav:false,
                dots:true,
                autoHeight:true
            },




            992:{
                items:3,
            },
        }
    });
}

if($('.service-slider-tab').length){

    $('.service-slider-tab').owlCarousel({
 
        responsiveClass:true,
        items:3,
        loop:true,
        dots:true,
        nav:false,
        autoHeight:true,
        navText:[
            "<div class='ion-ios-arrow-thin-left'>&nbsp;</div>","<div class='ion-ios-arrow-thin-right'>&nbsp;</div>"
        ],
        lazyLoad:true,
        autoplay:true,
        autoplayTimeout:5000,
        autoplayHoverPause:false,
        rewind:true,
        responsive:{

            0:{
                items:1
            },
             681:{
                items:2,
            },

            768:{
                items:3,
            },


            992:{
                items:3,
            },
        }
    });
}



if($('.service-menu-slider').length){
  
    $('.service-menu-slider').owlCarousel({
 
        responsiveClass:true,
        items:4,
        loop:false,
        dots:false,
        nav:false,
        autoHeight:false,
        navText:[
            "<div class='ion-ios-arrow-thin-left'>&nbsp;</div>","<div class='ion-ios-arrow-thin-right'>&nbsp;</div>"
        ],
        lazyLoad:true,
        autoplay:true,
        autoplayTimeout:5000,
        autoplayHoverPause:false,
        rewind:true,
        responsive:{

            0:{
                items:1
            },
             681:{
                items:2,
            },

            768:{
                items:3,
            },


            992:{
                items:4,
            },
        }
    });
}

if($('.cust-before-after-slider').length){
  $('.cust-before-after-slider').addClass('owl-carousel');
    $('.cust-before-after-slider').owlCarousel({
 
        responsiveClass:true,
        items:4,
        loop:false,
        dots:false,
        nav:true,
        autoHeight:false,
        navText:[
            "<div class='ion-ios-arrow-thin-left'>&nbsp;</div>","<div class='ion-ios-arrow-thin-right'>&nbsp;</div>"
        ],
        lazyLoad:true,
        autoplay:true,
        autoplayTimeout:5000,
        autoplayHoverPause:false,
        rewind:true,
        responsive:{

            0:{
                items:1
            },
             681:{
                items:2,
            },

            768:{
                items:3,
            },


            992:{
                items:4,
            },
        }
    });
}
if (window.innerWidth <= 767) {
if($('.cust-service-detail-img-slider').length){
  $('.cust-service-detail-img-slider').addClass('owl-carousel');
    $('.cust-service-detail-img-slider').owlCarousel({
 
        responsiveClass:true,
        items:1,
        loop:false,
        dots:false,
        nav:false,
        autoHeight:false,
        navText:[
            "<div class='ion-ios-arrow-thin-left'>&nbsp;</div>","<div class='ion-ios-arrow-thin-right'>&nbsp;</div>"
        ],
        lazyLoad:true,
        autoplay:true,
        autoplayTimeout:5000,
        autoplayHoverPause:false,
        rewind:true,
        responsive:{

            0:{
                items:1
            },
             681:{
                items:1,
            },

            768:{
                items:1,
            },


            992:{
                items:4,
            },
        }
    });
}
}
$(document).on('click', '#HeaderMenu-services', function() {
  // Add a delay before triggering the refresh
  setTimeout(function() {
    $('.service-menu-slider').trigger('refresh.owl.carousel');
    console.log('Owl Carousel has been refreshed after delay.');
  }, 1); // 500 milliseconds (0.5 seconds) delay
});

/*
document.addEventListener("DOMContentLoaded", function() {
  // Get the element with the ID cart-note-title
  const cartNoteTitle = document.getElementById("cart-note-title");
  
  // Add a click event listener
  cartNoteTitle.addEventListener("click", function() {
    // Find the next textarea element
    console.log('sdfsa');
    const textarea = cartNoteTitle.nextElementSibling;

    // Check if the next element is a textarea
    if (textarea && textarea.tagName.toLowerCase() === 'textarea') {
      // Toggle the display style
      textarea.style.display = (textarea.style.display === 'none' || textarea.style.display === '') ? 'block' : 'none';
    }
  });
});*/
$(document).ready(function(){ 

    $('#scroll').click(function(){ 
        $("html, body").animate({ scrollTop: 0 }, 1000); 
        return false; 
    });
  
});
document.addEventListener('DOMContentLoaded', function() {
  const thumbnails = document.querySelectorAll('#Slider-Thumbnails-template--16174778875983__main li');
  const prevBtn = document.getElementById('prev-btn');
  const nextBtn = document.getElementById('next-btn');
  let currentIndex = 0; // Start with the first thumbnail

  // Function to update the active thumbnail count and total
  function updateThumbnailInfo() {
    document.getElementById('thumbnail-info').innerHTML = `${currentIndex + 1} <span> / ${thumbnails.length}</span>`;
  }

  // Function to set the active thumbnail
  function setActiveThumbnail(index) {
    thumbnails.forEach((thumbnail, idx) => {
      if (idx === index) {
        thumbnail.querySelector('button').click(); // Simulate click on the thumbnail button
        thumbnail.classList.add('active'); // Optionally add an active class
      } else {
        thumbnail.classList.remove('active');
      }
    });
    updateThumbnailInfo();
  }

  // Initialize the first active thumbnail
  setActiveThumbnail(currentIndex);

  // Next button functionality (looping to the first thumbnail)
  nextBtn.addEventListener('click', function() {
    currentIndex = (currentIndex + 1) % thumbnails.length; // Increment and loop back to 0
    setActiveThumbnail(currentIndex);
  });

  // Previous button functionality (looping to the last thumbnail)
  prevBtn.addEventListener('click', function() {
    currentIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length; // Decrement and loop back to last
    setActiveThumbnail(currentIndex);
  });
});

